import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Catalyst from '@Services/Catalyst';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout';
import HeatmapCellDetailsDialogContent from '@Pages/Heatmap/HeatmapCellDetailsDialog/HeatmapCellDetailsDialogContent';
import { HEATMAP_CELL_DETAILS_DIALOG_CONTENT_CLASS_NAME } from './constants';

import './HeatmapCellDetailsDialog.custom.scss';
import './HeatmapCellDetailsDialog.theme.scss';

function HeatmapCellDetailsDialog({
  // From DialogsList
  closed,
  selfClose,

  // From open action
  matrixName,
  params,
  cellData,
  axisDescription,
}) {
  useEffect(() => {
    Catalyst.trackContentLinkClick('bioactivityDetail');
  }, []);

  return (
    <GeneralDialogLayout
      closed={closed}
      selfClose={selfClose}
      className="heatmap-cell-details-dialog"
      headerClassName="heatmap-cell-details-dialog__header"
      contentClassName={HEATMAP_CELL_DETAILS_DIALOG_CONTENT_CLASS_NAME}
      size="lg"
      movable
      header={<h3>Bioactivity detail</h3>}>
      <HeatmapCellDetailsDialogContent matrixName={matrixName} params={params} cellData={cellData} axisDescription={axisDescription} />
    </GeneralDialogLayout>
  );
}

HeatmapCellDetailsDialog.propTypes = {
  closed: PropTypes.bool,
  selfClose: PropTypes.func,
  matrixName: PropTypes.string,
  params: PropTypes.object,
  cellData: PropTypes.object,
  axisDescription: PropTypes.object,
};

export default HeatmapCellDetailsDialog;
